import Image from 'components/Basic/Image/Image';
import { useTypedTranslationFunction } from 'hooks/typescript/UseTypedTranslationFunction';
import twMerge from 'utils/twMerge';

type WarningBarProps = {
    className?: string;
};

export const WarningBar: FC<WarningBarProps> = ({ children, className }) => {
    const t = useTypedTranslationFunction();

    return (
        <div className={twMerge('flex w-full items-center gap-2 bg-[#ffe5c7] py-4 px-5 text-small', className)}>
            <Image width={18} height={18} src="/icons/exclamation-mark-warning.png" alt={t('Warning icon')} />
            {children}
        </div>
    );
};
